import { ChevronDown } from "lucide-react";
import type * as React from "react";

import { cn } from "../lib/cn";
import { inputClasses } from "./field";

/** A native select in the input style: keyboard, screen readers and phones handle it natively. */
export function Select({ className, children, ...props }: React.ComponentProps<"select">) {
  return (
    <span data-slot="select" className={cn("relative block", className)}>
      <select className={cn(inputClasses, "appearance-none pr-8")} {...props}>
        {children}
      </select>
      <ChevronDown
        aria-hidden
        strokeWidth={1.75}
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </span>
  );
}

export function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(inputClasses, "h-auto min-h-20 resize-y py-2 leading-5", className)}
      {...props}
    />
  );
}
